import { createFileRoute } from "@tanstack/react-router";
import { ForSmallBusinessComponent } from "@/pages/for-small-business";
import { head, loader } from "@/pages/for-small-business.meta";

export const Route = createFileRoute("/$locale/for-small-business")({
  loader,
  head,
  component: ForSmallBusinessComponent,
});
